import {
  ThemeProvider,
  CssBaseline,
  // Switch,
  // FormControlLabel,
} from '@mui/material';
import useThemeMode from './hooks/useThemeMode';
import AppRoutes from './routes';
import { Suspense, useEffect } from 'react';
import Loader from './components/Loader';
import applyThemeToCSS from './styles/applyThemeToCSS';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const App = () => {
  const { theme } = useThemeMode();
  useEffect(() => {
    applyThemeToCSS(theme);
  }, [theme]);

  return (
    <ThemeProvider theme={theme}>
      <Suspense fallback={<Loader />}>
        <CssBaseline />
        {/* <FormControlLabel
          control={
            <Switch
              checked={mode === 'dark'}
              onChange={toggleTheme}
              color='default'
            />
          }
          label={mode === 'light' ? '🌙' : '☀️'}
          sx={{
            position: 'fixed',
            zIndex: 99,
            top: 0,
            right: 0,
          }}
        /> */}

        <AppRoutes />
      </Suspense>
    </ThemeProvider>
  );
};

export default App;
